import { Routes, Route, Navigate } from "react-router-dom";
import { MarketingLayout } from "./layouts/marketing-layout.js";
import { AppLayout } from "./layouts/app-layout.js";
import { ProtectedRoute } from "./components/protected-route.js";
import { Landing } from "./routes/landing.js";
import { HowItWorks } from "./routes/how-it-works.js";
import { Home } from "./routes/home.js";
import { Reflect } from "./routes/reflect.js";
import { Companion } from "./routes/companion.js";
import { Library } from "./routes/library.js";
import { DesignSystem } from "./routes/design-system.js";
import { Terms } from "./routes/legal/terms.js";
import { Privacy } from "./routes/legal/privacy.js";
import { Analytics } from "./routes/legal/analytics.js";

// Auth surface — ported from the v3 brand handoff bundle.
import { SignIn } from "./routes/auth/sign-in.js";
import { SignUp } from "./routes/auth/sign-up.js";
import { Verify } from "./routes/auth/verify.js";
import { Forgot } from "./routes/auth/forgot.js";
import { CheckEmail } from "./routes/auth/check-email.js";
import { Reset } from "./routes/auth/reset.js";
import { Welcome } from "./routes/auth/welcome.js";
import { Profile } from "./routes/auth/profile.js";

export const App = () => (
  <Routes>
    {/* Public marketing surface */}
    <Route element={<MarketingLayout />}>
      <Route path="/" element={<Landing />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
    </Route>

    {/* Auth flow — public, each page brings its own split-screen shell.
        Flow: sign-up → verify(?new=1) → reset(?new=1) → welcome → /home
              sign-in → verify → welcome → /home  (code path)
              sign-in (pw) → welcome → /home
              forgot → check-email → reset → welcome → /home */}
    <Route path="/sign-in" element={<SignIn />} />
    <Route path="/sign-up" element={<SignUp />} />
    <Route path="/verify" element={<Verify />} />
    <Route path="/forgot" element={<Forgot />} />
    <Route path="/check-email" element={<CheckEmail />} />
    <Route path="/reset" element={<Reset />} />
    <Route path="/welcome" element={<Welcome />} />

    {/* Design system documentation — INTERNAL: reachable by direct URL only,
        no public links anywhere in the app. */}
    <Route path="/design-system" element={<DesignSystem />} />

    {/* Legal & transparency — public, own chrome */}
    <Route path="/terms" element={<Terms />} />
    <Route path="/privacy" element={<Privacy />} />
    <Route path="/analytics" element={<Analytics />} />

    {/* Profile sits inside the authed surface — requires a session
        so the sign-out button actually has something to clear. */}
    <Route
      path="/profile"
      element={
        <ProtectedRoute>
          <Profile />
        </ProtectedRoute>
      }
    />

    {/* Authed app shell */}
    <Route
      element={
        <ProtectedRoute>
          <AppLayout />
        </ProtectedRoute>
      }
    >
      <Route path="/home" element={<Home />} />
      <Route path="/reflect" element={<Reflect />} />
      <Route path="/companion" element={<Companion />} />
      <Route path="/library" element={<Library />} />
    </Route>

    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);
